
import React, { useState, useRef, useEffect } from 'react';

import { Route, Switch, useLocation } from "react-router-dom";
import Welcome from "./pages/welcome/Welcome";
import Webtoon from "./pages/webtoon/Webtoon";
import Movie from "./pages/movie/Movie";
import Audio from "./pages/audio/Audio";
import Novel from "./pages/novel/Novel";
import MyNavbar from "./components/UI/MyNavbar";

function App() {
  // let lastClick = 0;
  const location = useLocation();
  const [lastClick, setLastClick] = useState(0);
  const [watingClick, setWatingClick] = useState(null);
  const [showMenu, setShowMenu] = useState(true);

  const scrollInto = useRef(null)

  useEffect(() => {
    scrollInto.current.scrollIntoView()
  })

  const onClickHandler = e => {
    console.log('onClickHandler');
    if (
      lastClick &&
      e.timeStamp - lastClick < 250 &&
      watingClick
    ) {
      setLastClick(0);
      clearTimeout(watingClick);
      setWatingClick(null);
      if (location.pathname !== '/') {
        setShowMenu(!showMenu);
      }
    } else {
      setLastClick(e.timeStamp);
      setWatingClick(
        setTimeout(() => {
          setWatingClick(null);
        }, 250)
      );
    }
  }

  return (
    <div className="App" ref={scrollInto} onClick={onClickHandler}>
      <Switch>
        <Route path="/" exact>
          <Welcome />
        </Route>
        <Route path="/webtoon" exact>
          <Webtoon />
        </Route>
        <Route path="/movie" exact>
          <Movie />
        </Route>
        <Route path="/audio" exact>
          <Audio />
        </Route>
        <Route path="/novel" exact>
          <Novel />
        </Route>
        {/*
        <Route path="/news/:category">
          <CategoryNews />
        </Route> */}
      </Switch>
      {
        (location.pathname !== '/' && showMenu) &&
        <MyNavbar active={location.pathname}></MyNavbar>
      }
    </div>
  );
}

export default App;
